import React, {Component} from "react";
import Header from "components/Header/Header";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Button
} from 'react-bootstrap';
import Card from 'components/Card/Card.jsx';
import logo from "asset/img/logo/logo.png";
import {SendOtpCall, ResendOtpCall, VerifyOtpCall} from 'api/LoginApi.jsx';
import MaterialInput from "components/FormInputs/MaterialInput.jsx"
import ReactGA from 'react-ga';

export default class Login extends Component {
    constructor(props) {
        super(props);
        ReactGA.set({ userId: 123 });
        this.state = {
            cardHidden: true,
            loginDetails: [],
            errorMessage: null,
            showOTP: false,
            resendOTP: 30
        }
    }

    componentDidMount() {
        setTimeout(function () {
            this.setState({cardHidden: false});
        }.bind(this), 700);
        
    }

    componentWillMount() {
        this.loggedUser();
    }

    loggedUser = () => {
        if (localStorage.getItem('accessToken')) {
            const {history} = this.props;
            history.push('/');
        }
    }

    login = () => {
        this.setState({errorMessage: null})
        let loginCredentials = this.state.loginDetails;
        console.log(loginCredentials)
        if (Object.keys(loginCredentials).length === 0) {
            this.setState({
                errorMessage: "Mobile number is missing or incomplete. Please correct your entries and try agai" +
                        "n."
            })
            return;
        }

        if (loginCredentials.mobile.length != 10) {
            this.setState({errorMessage: "Please enter 10-digit valid mobile number without country code"})
            return;
        }

        if (loginCredentials.mobile.length === 10 && this.state.showOTP == false) {
            this.sendOTP(loginCredentials.mobile)
            return
        }

        if (loginCredentials.otp === undefined) {
            this.setState({errorMessage: "OTP is missing or incomplete. Please correct and retry"})
            return;
        }
        if (loginCredentials.otp.length === undefined || loginCredentials.otp.length !== 6) {
            this.setState({errorMessage: "Please enter 6-digit valid OTP"})
            return;
        }

        if (loginCredentials.mobile.length === 10 && loginCredentials.otp.length === 6) {
            this.verifyOTP(loginCredentials.mobile, loginCredentials.otp)
        }
    }

    otpTimer = () => {
        if(this.state.stopTimer){
            this.setState({resendOTP:30})
        }
        if(this.state.resendOTP > 0){
            this.setState({resendOTP:(--this.state.resendOTP)})
            if(this.state.stopTimer){
                this.setState({resendOTP:30})
                this.setState({stopTimer: false})
            }else{
                setTimeout(this.otpTimer, 1000);
            }
            
        }

    }

    sendOTP = (mobile) => {
        ReactGA.event({
            category: 'User',
            action: 'Clicked on Send OTP'
          });          
        this.setState({showOTP: true})
        SendOtpCall(mobile).then((res) => { 
            this.setState({showOTP: true})
            setTimeout(this.otpTimer, 1000);
        }).catch(err => {     
            this.setState({ errorMessage: err})
        });
    }

    resendOTP = () => {
        ReactGA.event({
            category: 'User',
            action: 'Clicked on Resend OTP'
          });
          
        this.setState({showOTP: true})
        ResendOtpCall().then((res) => { 
            this.setState({showOTP: true})
            setTimeout(this.otpTimer, 1000);
        }).catch(err => {     
            this.setState({ errorMessage: err})
        });
    }

    wrongNumber = () => {
        ReactGA.event({
            category: 'User',
            action: 'Clicked on wrong number'
          });
        this.setState({stopTimer: true})
        this.setState({showOTP: false})
    }

    verifyOTP = (mobile, otp) => {
        ReactGA.event({
            category: 'User',
            action: 'Clicked on Verify OTP'
          });
          
        VerifyOtpCall(mobile, otp).then((res) => {
            ReactGA.event({
                category: 'User',
                action: 'User get verified'
            });
            ReactGA.set({ userId: 123 });
            this.loggedUser();
        }).catch(err => {     
            this.setState({ errorMessage: err})
        });
    }

    onChange = (event) => {
        let loginDetails = this.state.loginDetails;
        loginDetails[event.target.name] = event.target.value;
        this.setState({"loginDetails": loginDetails});
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    }

    render() {
        return (
            <div>
                <Grid fluid className="login-page">
                    <Row>
                        <Header className="transparent"/>
                        <Col lg={4} md={6} sm={8} mdOffset={3} smOffset={2} lgOffset={4}>
                            <form className="login-form">
                                <Card
                                    textCenter
                                    title="Welcome"
                                    category="Login to access your medical reports"
                                    content={
                                        <div className = "login-content-div" > 
                                        <MaterialInput
                                            name="mobile"
                                            type="number"
                                            grpclassname="margin-btm-45"
                                            disabled={this.state.showOTP}
                                            onChange={this.onChange}
                                            onKeyPress={this.handleKeyPress}
                                            autoFocus
                                            title="Enter 10-digit mobile number without country code"
                                            label="Mobile"/>
                                        {this.state.showOTP? 
                                                <div>
                                                    <MaterialInput
                                                        name="otp"
                                                        type="number"
                                                        onChange={this.onChange}
                                                        title="Enter 6-digits OTP number"
                                                        label="One Time Password (OTP)"/>
                                                    {this.state.resendOTP > 0 ? 
                                                        <p>You can resend OTP in {this.state.resendOTP} sec</p>: 
                                                        <a onClick={this.resendOTP}>Resend</a>}
                                                </div>: ""
                                            } 
                                        <p className="text-danger" style={{textAlign: 'center'}}>
                                            {this.state.errorMessage} 
                                        </p> 
                                    </div>
                                    }
                                    legend={
                                    <div> 
                                        <Button
                                            bsStyle='success'
                                            onClick={this.login}
                                            bsSize="large"
                                            className={'loginBtn'}>
                                                {this.state.showOTP
                                                    ? "Verify"
                                                    : "Send OTP"}
                                        </Button> 
                                        {this.state.showOTP? <a onClick={this.wrongNumber}>Entered a wrong number?</a>:""}
                                    </div>}
                                    ftTextCenter/>
                            </form>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Login.jsx